import { get, set, del } from 'idb-keyval';
import type { Wedding, WeddingEvent, UserPreferences } from './types';
import { DEFAULT_PREFERENCES } from './constants';

const KEYS = {
  WEDDING: 'wedtrack:wedding',
  EVENTS: 'wedtrack:events',
  PREFERENCES: 'wedtrack:preferences',
  WEDDING_ID: 'wedtrack:weddingId',
} as const;

export async function getWedding(): Promise<Wedding | null> {
  return (await get<Wedding>(KEYS.WEDDING)) ?? null;
}

export async function setWedding(wedding: Wedding): Promise<void> {
  await set(KEYS.WEDDING, wedding);
  await set(KEYS.WEDDING_ID, wedding.id);
}

export async function clearWedding(): Promise<void> {
  await del(KEYS.WEDDING);
  await del(KEYS.WEDDING_ID);
}

export async function getWeddingId(): Promise<string | null> {
  return (await get<string>(KEYS.WEDDING_ID)) ?? null;
}

export async function getEvents(): Promise<WeddingEvent[]> {
  return (await get<WeddingEvent[]>(KEYS.EVENTS)) ?? [];
}

export async function setEvents(events: WeddingEvent[]): Promise<void> {
  await set(KEYS.EVENTS, events);
}

export async function clearEvents(): Promise<void> {
  await del(KEYS.EVENTS);
}

export async function getPreferences(): Promise<UserPreferences> {
  const stored = await get<UserPreferences>(KEYS.PREFERENCES);
  if (!stored) return { ...DEFAULT_PREFERENCES, categoryFilter: [...DEFAULT_PREFERENCES.categoryFilter] };
  return stored;
}

export async function setPreferences(prefs: UserPreferences): Promise<void> {
  await set(KEYS.PREFERENCES, prefs);
}

export async function updatePreferences(
  updates: Partial<UserPreferences>
): Promise<UserPreferences> {
  const current = await getPreferences();
  const updated = { ...current, ...updates };
  await setPreferences(updated);
  return updated;
}
